/* tslint:disable */
/* eslint-disable */
/**
 * Micro Interactions B Service
 * API for micro-interactions
 *
 * The version of the OpenAPI document: 1.0
 * Contact: DL-IT_Pet_Profile@chewy.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
  ApiElementBack,
  ApiElementBackFromJSON,
  ApiElementBackFromJSONTyped,
  ApiElementBackToJSON,
} from './ApiElementBack';
import {
  ApiElementDismiss,
  ApiElementDismissFromJSON,
  ApiElementDismissFromJSONTyped,
  ApiElementDismissToJSON,
} from './ApiElementDismiss';
import {
  ApiElementFeedback,
  ApiElementFeedbackFromJSON,
  ApiElementFeedbackFromJSONTyped,
  ApiElementFeedbackToJSON,
} from './ApiElementFeedback';
import {
  ApiElementLink,
  ApiElementLinkFromJSON,
  ApiElementLinkFromJSONTyped,
  ApiElementLinkToJSON,
} from './ApiElementLink';
import { ApiEvent, ApiEventFromJSON, ApiEventFromJSONTyped, ApiEventToJSON } from './ApiEvent';
import {
  ApiSaveState,
  ApiSaveStateFromJSON,
  ApiSaveStateFromJSONTyped,
  ApiSaveStateToJSON,
} from './ApiSaveState';

/**
 *
 * @export
 * @interface ApiElement
 */
export interface ApiElement {
  /**
   *
   * @type {ApiElementBack}
   * @memberof ApiElement
   */
  back?: ApiElementBack;
  /**
   *
   * @type {ApiElementBack}
   * @memberof ApiElement
   */
  avatar?: ApiElementBack;
  /**
   *
   * @type {ApiElementDismiss}
   * @memberof ApiElement
   */
  dismiss?: ApiElementDismiss;
  /**
   *
   * @type {string}
   * @memberof ApiElement
   */
  icon?: string;
  /**
   *
   * @type {ApiElementLink}
   * @memberof ApiElement
   */
  link?: ApiElementLink;
  /**
   *
   * @type {ApiElementFeedback}
   * @memberof ApiElement
   */
  feedback?: ApiElementFeedback;
  /**
   *
   * @type {ApiEvent}
   * @memberof ApiElement
   */
  event?: ApiEvent;
  /**
   *
   * @type {string}
   * @memberof ApiElement
   */
  text?: string;
  /**
   *
   * @type {ApiSaveState}
   * @memberof ApiElement
   */
  saveState?: ApiSaveState;
}

export function ApiElementFromJSON(json: any): ApiElement {
  return ApiElementFromJSONTyped(json, false);
}

export function ApiElementFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiElement {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    back: !exists(json, 'back') ? undefined : ApiElementBackFromJSON(json['back']),
    avatar: !exists(json, 'avatar') ? undefined : ApiElementBackFromJSON(json['avatar']),
    dismiss: !exists(json, 'dismiss') ? undefined : ApiElementDismissFromJSON(json['dismiss']),
    icon: !exists(json, 'icon') ? undefined : json['icon'],
    link: !exists(json, 'link') ? undefined : ApiElementLinkFromJSON(json['link']),
    feedback: !exists(json, 'feedback') ? undefined : ApiElementFeedbackFromJSON(json['feedback']),
    event: !exists(json, 'event') ? undefined : ApiEventFromJSON(json['event']),
    text: !exists(json, 'text') ? undefined : json['text'],
    saveState: !exists(json, 'saveState') ? undefined : ApiSaveStateFromJSON(json['saveState']),
  };
}

export function ApiElementToJSON(value?: ApiElement | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    back: ApiElementBackToJSON(value.back),
    avatar: ApiElementBackToJSON(value.avatar),
    dismiss: ApiElementDismissToJSON(value.dismiss),
    icon: value.icon,
    link: ApiElementLinkToJSON(value.link),
    feedback: ApiElementFeedbackToJSON(value.feedback),
    event: ApiEventToJSON(value.event),
    text: value.text,
    saveState: ApiSaveStateToJSON(value.saveState),
  };
}
